import React, { type ComponentProps } from 'react';
import { cssMap } from '@compiled/react';
import { Box } from '@atlaskit/primitives/compiled';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { I18nProvider } from '@atlassian/embedded-confluence-common';
import fetchTranslations from '../i18n/fetchTranslations';

const styles = cssMap({
	fallback: {
		width: '100%',
		height: '100%',
	},
});

const LazyWhiteboard = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_embedded-confluence-whiteboard" */
			'./Whiteboard'
		),
);

export type WhiteboardProps = ComponentProps<typeof LazyWhiteboard> & {
	locale?: string;
};

export const Whiteboard = (props: WhiteboardProps) => (
	<I18nProvider locale={props.locale} fetchTranslations={fetchTranslations}>
		<LazySuspense fallback={<Box xcss={styles.fallback}></Box>}>
			<LazyWhiteboard {...props} />
		</LazySuspense>
	</I18nProvider>
);
